import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = () => {
    const { user, initialized } = useAuth();
    const location = useLocation();

    if (!initialized) {
        return null;
    }

    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
